var exports = {
  "Hero": "Hero__q20VZ7",
  "Hero__background": "Hero__background__X-Osn-",
  "Hero__background--isHidden": "Hero__background--isHidden__UIeUPq",
  "Hero__container": "Hero__container__CpYbE5",
  "Hero__content": "Hero__content__X3T2LC",
  "Hero__heroBlock": "Hero__heroBlock__aVvIXg",
  "Hero__title": "Hero__title__GlMJCz",
  "PricingPlans": "PricingPlans__zQVrUQ",
};

__webpack_require__.r(module.exports = exports);
